import {
  getPaletteForNumberOfBuckets,
  type SemanticLegendPalette,
} from './colorPalettes';

export const DEFAULT_COLOR = '#000000';

export function getColorFromValue(
  bucketNumber: number,
  numberOfBuckets: number,
  semanticLegendPalette: SemanticLegendPalette
) {
  const palette = getPaletteForNumberOfBuckets(
    semanticLegendPalette,
    numberOfBuckets
  );
  if (palette.length > bucketNumber) {
    return palette[bucketNumber];
  }
  return DEFAULT_COLOR;
}
